import { Model } from 'modules/core/lib/mobx-rest'

interface IRestDay {
  id: number
  date: string
  state: string
  employee_id: number
}

class RestDay extends Model<IRestDay> {
  static urlRoot() {
    return '/shift_management/rest_days'
  }
}

export default RestDay
